import type {
  QueryFunctionContext,
  UseQueryResult,
} from '@tanstack/react-query';
import { useQuery } from '@tanstack/react-query';
import groq from 'groq';
import {
  CAMPAIGN_BLOCKS,
  CAMPAIGN_REBUS_HERO,
  PROMO_CODE,
  PROMO_HERO,
  SEO,
  SLUG,
} from 'lib/queries';
import { client } from 'lib/sanity';
import type { LandingPage } from 'types/cms/pages/LandingPage';

type LandingPageQuery = UseQueryResult & {
  data: LandingPage;
};

export const LANDING_PAGE_KEY = 'landingPage';

type LandingPageQueryKey = [string, string];

export const fetchLandingPage = async ({
  queryKey,
}: QueryFunctionContext<LandingPageQueryKey>) => {
  const query = groq`
  *[ _type == 'timeline_landingPage' && slug.current == $slug][0] {
    ${SLUG},
    ${SEO},
    title,
    "isSkincarePath": coalesce(isSkincarePath, false),
    ${PROMO_CODE},
    ${PROMO_HERO},
    ${CAMPAIGN_REBUS_HERO},
    termsAndConditions,
    "blocks": coalesce(template -> blocks[] { ${CAMPAIGN_BLOCKS} }, blocks[]{ ${CAMPAIGN_BLOCKS} })
  }
  `;

  const landingPage: LandingPage = await client.fetch(query, {
    slug: queryKey[1],
  });

  return landingPage;
};

export const useLandingPage = (slug: string) =>
  useQuery({
    queryKey: [LANDING_PAGE_KEY, slug],
    queryFn: fetchLandingPage,
  }) as LandingPageQuery;
